import { render, staticRenderFns } from "./Teaser.vue?vue&type=template&id=a97effd4&scoped=true&"
import script from "./Teaser.vue?vue&type=script&lang=ts&"
export * from "./Teaser.vue?vue&type=script&lang=ts&"
import style0 from "./Teaser.vue?vue&type=style&index=0&id=a97effd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97effd4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VContainer,VImg,VSheet})
